import React, { useEffect, useState } from 'react';

export default function IntegerInput({
  value,
  onChange,
  onFocus,
  readOnly,
  placeholder,
  min,
  max,
  ...props
}) {
  const [digits, setDigits] = useState('');

  useEffect(() => {
    if (value === undefined || value === null || value === '') {
      setDigits('');
      return;
    }
    const num = typeof value === 'number' ? value : parseInt(String(value), 10);
    if (!isNaN(num)) {
      setDigits(String(num));
    }
  }, [value]);

  const emit = (d) => {
    const val = Number(d || 0);
    if (onChange) onChange({ target: { value: val, name: props.name } });
  };

  const normalizeDigits = (value) => value.replace(/^0+/, '') || '0';

  const isAllowedValue = (nextDigits) => {
    if (nextDigits === '') return true;
    const numericValue = Number(nextDigits);
    if (Number.isNaN(numericValue)) return false;
    if (min !== undefined && min !== null && numericValue < Number(min)) return false;
    if (max !== undefined && max !== null && numericValue > Number(max)) return false;
    return true;
  };

  const handleKeyDown = (e) => {
    if (readOnly) return;

    const { selectionStart = digits.length, selectionEnd = digits.length } = e.currentTarget;
    const hasSelection = selectionStart !== selectionEnd;
    const replaceSelection = (nextValue) => `${digits.slice(0, selectionStart)}${nextValue}${digits.slice(selectionEnd)}`;

    if (/^[0-9]$/.test(e.key)) {
      e.preventDefault();
      const nextDigits = hasSelection
        ? normalizeDigits(replaceSelection(e.key))
        : normalizeDigits(`${digits}${e.key}`);
      if (!isAllowedValue(nextDigits)) return;
      setDigits(nextDigits);
      emit(nextDigits);
      return;
    }

    if (e.key === 'Backspace') {
      e.preventDefault();
      const nextDigits = hasSelection
        ? digits.slice(0, selectionStart) + digits.slice(selectionEnd)
        : digits.slice(0, Math.max(selectionStart - 1, 0)) + digits.slice(selectionEnd);
      setDigits(nextDigits);
      emit(nextDigits);
      return;
    }

    if (e.key === 'Delete') {
      e.preventDefault();
      const nextDigits = hasSelection
        ? digits.slice(0, selectionStart) + digits.slice(selectionEnd)
        : digits.slice(0, selectionStart) + digits.slice(selectionStart + 1);
      setDigits(nextDigits);
      emit(nextDigits);
    }
  };

  const handleFocus = (e) => {
    e.target.select();
    if (onFocus) {
      onFocus(e);
    }
  };

  const inputProps = {
    ...props,
    type: 'text',
    value: digits,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    readOnly,
  };

  if (!readOnly && placeholder !== undefined) {
    inputProps.placeholder = placeholder;
  }

  return <input {...inputProps} />;
}
